<template>
  <div id="app">
    <header>
      <div class="wrapper">
        <Logo />
        <Menu />
        <Mobile />
      </div>
    </header>
    <main>
      <router-view/>
    </main>
  </div>
</template>

<script>
import Logo from '@/components/Logo'
import Menu from '@/components/Menu'
import Mobile from '@/components/Mobile'
export default {
  name: 'App',
  components: {
    Logo,
    Menu,
    Mobile
  }
}
</script>

<style lang="less">
@blue: #6AB6BE;
@blue-dark: #65ABB2;
@grey: #646464;
@grey-dark: #3e3e3e;

.wrapper {
  margin: 0 auto;
  max-width: 1200px;
  padding: 0 24px;
}

.button {
  background: @blue;
  border-radius: 8px;
  color: #fff;
  display: inline-block;
  font-size: 20px;
  font-weight: 700;
  padding: 16px 24px;
  text-decoration: none;

  &:hover { background: @blue-dark }
}

header {
  padding: 24px 0;
  position: absolute;
  top: 0; left: 0;
  width: 100%;
  z-index: 2;

  .wrapper {
    align-items: center;
    display: flex;
    justify-content: space-between;
  }

  nav {
    ul {
      display: flex;
      list-style: none;
      margin: 0; padding: 0;

      li {
        margin: 0 16px;

        a {
          color: #fff;
          font-size: 20px;
          font-weight: 700;
          position: relative;
          text-decoration: none;

          &:hover { text-decoration: underline }

          &.module {
            &:before {
              color: @blue;
              content: "MODULE";
              font-size: 16px;
              position: absolute;
              top: -24px;
            }
          }
        }
      }
    }
  }
}

.content {
  padding: 80px 0;

  h2 {
    color: @blue;
    font-size: 48px;
    letter-spacing: -1px;
    margin: 0 0 0.8em;
    text-align: center;
    a {
      color: @blue;
      font-size: 48px;
      letter-spacing: -1px;
      margin: 0 0 0.8em;
      text-align: center;
      text-decoration: none;
    }
  }

  .modules_grid {
    display: grid;
    gap: 40px;
    grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));

    @media screen and (max-width: 360px) {
      grid-template-columns: repeat(auto-fit,minmax(300px,1fr));
    }

    .module {
      border-radius: 24px;
      box-shadow: 0 0 12px rgba(0,0,0,0.2);
      display: flex;
      flex-direction: column;
      padding: 32px;

      h3 {
        font-size: 32px;
        letter-spacing: -1px;
        margin: 0 0 0.4em;
      }

      p {
        color: @grey;
        flex-grow: 1;
        font-size: 20px;
        letter-spacing: -1px;
        line-height: 1.5;
        margin: 0 0 0.6em;

        a {
          color: @blue;
          text-decoration: none;
        }
      }

      a.button { align-self: flex-end }
    }
  }
}

/*.transform(@transform) {
  -webkit-transform: @transform;
  -moz-transform: @transform;
  -ms-transform: @transform;
  -o-transform: @transform;
  transform: @transform;
}*/
</style>



// WEBPACK FOOTER //
// src/App.vue